import { renderRichText, storyblokEditable } from '@storyblok/react';
import clsx from 'clsx';
import { FC } from 'react';
import { ContentAccordionStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { ReactMarkdown } from 'molecules/Markdown';
import styles from './styles.module.css';

export const TextImageBlock: FC<{ blok: ContentAccordionStoryblok }> = ({
  blok,
}) => {
  return (
    <div
      className={clsx(
        styles.imageTextBlock,
        blok.upscaledImage && styles.upScaledImage,
      )}
      {...storyblokEditable(blok)}
    >
      <div className={styles.textBlockImageContainer}>
        <Image
          src={blok.image.filename}
          alt={blok.image.alt}
          className={clsx(
            styles.textBlockImage,
            blok.upscaledImage && styles.upScaledEl,
          )}
        />
      </div>
      <div className={clsx(blok.upscaledImage && styles.textblockContainer)}>
        <ReactMarkdown
          className={styles.imageBlockText}
          text={renderRichText(blok.text)}
        />
      </div>
    </div>
  );
};
